const $ = window.jQuery;
const $window = $window || $(window);

const Testimonial = {

    init() {
        var $module = $('.Testimonial');
        if (!$module.length)
            return;

        $module.each((index, element) => {
            this.each(element);
        });
    },

    each(element) {

        let $item = $(element);

        let $quote = $item.find('.Testimonial__quote');
        let lineHeight = parseInt(jQuery($quote).css('line-height'));
        let maxLines = 6;

        if ($quote.height() > lineHeight * maxLines) {
            $quote.css({
                height: lineHeight * maxLines,
                overflow: 'hidden',
            });

            $quote.find('.Testimonial__quote-reveal')
                .removeClass('hidden')
                .click(function () {
                    $quote.css({
                        height: 'auto',
                        overflow: 'visible',
                    });
                    $(this).remove();
                });
        }

    }

};

export default Testimonial;